"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const rolesQuery_1 = require("../../../../queries/rolesQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const invitePeopleAside_1 = __importDefault(require("../../../organisms/createTeamModal/invitePeopleAside"));
const AddCompanyAdminAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./addCompanyAdminAside'))));
const role = (0, rolesQuery_1.getRoleV2)('companyAdmin');
const ADMIN_OPERATION = '15';
const SECURITYGROUP = '946_070';
const groupId = '35dea17e-fdd7-46d9-88c8-c5c632ebf92b';
const CompanySettingsAsides = ({ openRemoveUserAside, selectedUser, toggleRemoveAdminAside, onRemoveAdmin, }) => {
    const { data: hasAccess } = (0, userQuery_1.useGetVerifyUserAccess)({
        objectId: SECURITYGROUP,
        operationId: ADMIN_OPERATION,
        groupId,
        teamId: undefined,
        userId: undefined,
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(AddCompanyAdminAside, {}) }), (0, jsx_runtime_1.jsxs)(material_1.Dialog, { open: openRemoveUserAside, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, { id: "alert-dialog-title", sx: { padding: 1 }, children: strings_1.companySettingsOverviewStrings.CONFIRM_ACTION_TITLE }), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { sx: { padding: 0 }, children: (0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "warning", children: strings_1.companySettingsOverviewStrings.REMOVE_ADMIN_CONFIRMATION_MESSAGE({
                                name: selectedUser?.fullName || '',
                            }) }) }), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "yes-btn", onClick: onRemoveAdmin, color: uiConstants_1.UI_BUTTON_SECONDARY, label: strings_1.companySettingsTeamsStrings.YES_BUTTON_TEXT, style: { width: '20%' } }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-btn", onClick: toggleRemoveAdminAside, color: uiConstants_1.UI_BUTTON_SECONDARY, label: strings_1.companySettingsTeamsStrings.CANCEL_BUTTON_TEXT })] })] }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(invitePeopleAside_1.default, { onCloseShouldOpenAddAdminAside: true, typeId: 'mappedTSRoleId', role: role, tsAdmin: Boolean(hasAccess) }) })] }));
};
exports.default = CompanySettingsAsides;
